import { Fade } from "@mui/material";
import "./Games.css";
import { animated, useSpring } from "@react-spring/web";
import { windowFullWidth } from "../../utils/UIHelper";
import { useEffect, useRef, useState } from "react";
import WorkCard from "../../components/WorkCard/WorkCard";
import { appList } from "../../assets/DATA";

const Games = ({ pageBehaviour }: any) => {
	const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
	const workListRef: React.LegacyRef<HTMLDivElement> = useRef(null);
	const [work, setWork] = useSpring(() => ({
		from: { x: windowFullWidth },
	}));
	useEffect(() => {
		const handleResize = () => {
			const windowWidth = window.innerWidth;
			setIsMobile(windowWidth <= 768);
		};

		window.addEventListener("resize", handleResize);
		return () => {
			window.removeEventListener("resize", handleResize);
		};
	}, []);

	return (
		<div className="games-container-box">
			<Fade in timeout={{ enter: 1500, exit: 500 }}>
				<div
					className="work-list"
					ref={workListRef}
					style={{
						paddingInline: isMobile ? "4vw" : "15vw",
						transition: "all 0.5s",
					}}
				>
					{appList.map((item, index) => (
						<WorkCard
							key={index}
							isMobile={isMobile}
							onClick={() => {
								// setSelectedAppImages(
								// 	item.appImages ??
								// 		[]
								// );
								// setPhoneModalVisible(
								// 	true
								// );
								window.open(item.url, "_blank");
							}}
							backgroundImage={item.bgImage}
							titleImage={item.titleImage}
							logo={item.logo}
						/>
					))}
				</div>
			</Fade>
		</div>
	);
};

export default Games;
